import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,_vm._l((_vm.widgets),function(widget,index){return _c('Widget',{key:index,attrs:{"position":widget.widget_type.code,"url":_vm.getUrl(widget),"url_title":_vm.getUrlTitle(widget),"title":_vm.getTitle(widget),"html":_vm.getContent(widget),"image_url":_vm.getImageUrl(widget)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }